// import React from "react";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import axios from "axios";
// import cookie from "react-cookies";
// import Select from "react-select";
// import { ENTERPRISE_URL, UNIFIED_BASE_URL } from "../../webbase";
// class Switche extends React.Component {
//   constructor() {
//     super();
//     this.state = {
//       userEmail: cookie.load("useAdmin"),
//       token: cookie.load("tokenAdmin"),
//       ratios: [],
//       users: [],
//       merchants: [],
//       selectedDealer: "",
//       selectedMerchant: "",
//       ratio: "1",
//       network: [
//         { value: "mtn", label: "MTN" },
//         { value: "airtel", label: "Airtel" },
//         { value: "glo", label: "Glo" },
//         { value: "9mobile", label: "9mobile" },
//       ],
//       selectedNetwork: { value: "mtn", label: "MTN" },
//       isLoading: false,
//       dealerSelected: false
//     };
//     this.getRatios = this.getRatios.bind(this);
//     this.getDealers = this.getDealers.bind(this);
//     this.getMerchants = this.getMerchants.bind(this);
//     this.onSubmit = this.onSubmit.bind(this);
//   }



//   onSubmit = (event) => {
//     event.preventDefault();
//     this.setState({ isLoading: true });
    
//     const data = {
//       dealerId: this.state.selectedDealer,
//       telconame: this.state.selectedNetwork.value,
//       merchantId: this.state.selectedMerchant,
//       ratio: this.state.ratio,
//     }

//     axios
//       .post(`${UNIFIED_BASE_URL}/manage/switch-or-ratio-dealer`, data, {
//         headers: {
//           authorization: this.state.token,
//         },
//       })
//       .then((res) => {
//         this.setState({ isLoading: false });
//         if (res.data.status === "2000") {
//           toast.success(res.data.description);
//           this.getRatios();
//         } else {
//           toast.error(res.data.description);
//         }
//       })
//       .catch((err) => {
//         this.setState({ isLoading: false });
//         toast.error("An error occurred. Please try again.");
//         console.log(err);
//       });
//   };

//   //get all users
//   getRatios() {
//     axios
//       .get(ENTERPRISE_URL + "/manage/get-dealer-router-config", {
//         headers: {
//           authorization: this.state.token,
//         },
//       })
//       .then((res) => {
//         console.log(res.data);
//         if (res.data.status === "2000") {
//           this.setState({
//             ratios: res.data.data,
//           });
//         } else {
//           toast.error(res.data.description);
//         }
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   }

//   getDealers() {
//     this.setState({ isLoading: true });
//     axios
//       .get(`${UNIFIED_BASE_URL}/manage/get-dealer`, {
//         headers: {
//           authorization: this.state.token,
//         },
//       })
//       .then((res) => {
//         if (res.data.status === "2000") {
//           const dealers = res.data.data.map(dealer => ({
//             value: dealer.dealerId,
//             label: dealer.dealerId
//           }));
          
//           this.setState({
//             users: dealers,
//             isLoading: false
//           });
          
//           // Remove auto-selection of first dealer
//           // We want the user to explicitly select a dealer
//         } else {
//           this.setState({ isLoading: false });
//           toast.error(res.data.description);
//         }
//       })
//       .catch((err) => {
//         this.setState({ isLoading: false });
//         toast.error("Failed to fetch dealers");
//         console.log(err);
//       });
//   }

//   // getMerchants(dealer) {
//   //   this.setState({ isLoading: true, merchants: [] });
    
//   //   axios
//   //     .get(`${UNIFIED_BASE_URL}/onboarding/stp-users?dealerId=${dealer}`, {
//   //       headers: {
//   //         authorization: this.state.token,
//   //       },
//   //     })
//   //     .then((res) => {
//   //       if (res.data.status === "200") {
//   //         const merchants = res.data.map(merchant => ({
//   //           value: merchant.businessEmail, // Use businessEmail as the value for API payload
//   //           label: merchant.businessName || `${merchant.firstName || ''} ${merchant.lastName || ''}`.trim() // Display businessName if available, fallback to firstName lastName
//   //         }));
          
//   //         this.setState({
//   //           merchants: merchants,
//   //           isLoading: false
//   //         });
          
//   //         if (merchants.length > 0) {
//   //           this.setState({ selectedMerchant: merchants[0].value });
//   //         }
//   //       } else {
//   //         this.setState({ isLoading: false });
//   //         toast.error(res.data.description);
//   //       }
//   //     })
//   //     .catch((err) => {
//   //       this.setState({ isLoading: false });
//   //       toast.error("Failed to fetch merchants");
//   //       console.log(err);
//   //     });
//   // }
//   getMerchants(dealer) {
//     this.setState({ isLoading: true, merchants: [] });
    
//     axios
//       .get(`${UNIFIED_BASE_URL}/onboarding/get-merchant-by-dealerId?dealerId=${dealer}`, {
//         headers: {
//           authorization: this.state.token,
//         },
//       })
//       .then((res) => {
//         // Check for API-level success status ("2000")
//         // if (res.data.status === "2000") {
//         //   // Access merchants array from response data
//         //   const merchants = res.data.data.merchants.map(merchant => ({
//         //     value: merchant.businessEmail,
//         //     label: merchant.businessName || 
//         //            [merchant.firstName, merchant.lastName].filter(Boolean).join(' ') || 
//         //            merchant.businessEmail
//         //   }));
          
//         //   this.setState({
//         //     merchants: merchants,
//         //     isLoading: false
//         //   });
          
//         //   if (merchants.length > 0) {
//         //     this.setState({ selectedMerchant: merchants[0].value });
//         //   }
//         // } else {
//         //   this.setState({ isLoading: false });
//         //   toast.error(res.data.description || "Failed to load merchants");
//         // }
//         if (res.data.status === "2000") {
//           const merchantArray = Array.isArray(res.data.data.merchants)
//             ? res.data.data.merchants
//             : res.data.data; // fallback if API returns an array directly
        
//           const merchants = (merchantArray || []).map(merchant => ({
//             value: merchant.businessEmail,
//             label: merchant.businessName || 
//                    [merchant.firstName, merchant.lastName].filter(Boolean).join(' ') || 
//                    merchant.businessEmail
//           }));
        
//           this.setState({
//             merchants,
//             isLoading: false
//           });
        
//           if (merchants.length > 0) {
//             this.setState({ selectedMerchant: merchants[0].value });
//           }
//         } else {
//           this.setState({ isLoading: false });
//           toast.error(res.data.description || "Failed to load merchants");
//         }
        
//       })
//       .catch((err) => {
//         this.setState({ isLoading: false });
//         toast.error("Failed to fetch merchants");
//         console.log(err);
//       });
//   }
//   componentDidMount() {
//     this.getRatios();
//     this.getDealers();
//   }

//   render() {
//     return (
//       <main className="page-content">
//         <ToastContainer
//           position="top-center"
//           autoClose={3000}
//           hideProgressBar={false}
//           newestOnTop={false}
//           closeOnClick
//           rtl={false}
//           pauseOnFocusLoss
//           draggable
//           pauseOnHover
//         />
//         <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
//           <div className="ps-3">
//             <nav aria-label="breadcrumb">
//               <ol className="breadcrumb mb-0 p-0">
//                 <li className="breadcrumb-item">
//                   <a href="javascript:;">
//                     <i className="bx bx-home-alt"></i>
//                   </a>
//                 </li>
//                 <li className="breadcrumb-item active" aria-current="page">
//                   All Dealer Ratios
//                 </li>
//               </ol>
//             </nav>
//           </div>
//           <div className="ms-auto"></div>
//         </div>

//         <div className="card">
//           <div className="card-body">
//             <form className="row">
//               <div className="row mb-3">
//                 <div className="col-lg-4 col-md-4">
//                   <label className="form-label">Dealer</label>
//                   <Select
//                     className="basic-single"
//                     classNamePrefix="select"
//                     isLoading={this.state.isLoading}
//                     isSearchable={true}
//                     name="dealer"
//                     options={this.state.users}
//                     onChange={(selectedOption) => {
//                       this.setState({ 
//                         selectedDealer: selectedOption.value,
//                         dealerSelected: true,
//                         selectedMerchant: "",
//                         merchants: [] 
//                       });
//                       this.getMerchants(selectedOption.value);
//                     }}
//                   />
//                 </div>

//                 {this.state.dealerSelected && (
//                <div className="col-lg-4 col-md-4">
//                <label className="form-label">Merchant</label>
//                {this.state.isLoading ? (
//                  <div className="form-control">Loading merchants...</div>
//                ) : this.state.merchants.length === 0 ? (
//                  <div className="text-danger">No merchants found for this dealer</div>
//                ) : (
//                  <Select
//                    className="basic-single"
//                    classNamePrefix="select"
//                    isSearchable={true}
//                    name="merchant"
//                    options={this.state.merchants}
//                    onChange={(selectedOption) => {
//                      this.setState({ selectedMerchant: selectedOption.value });
//                    }}
//                  />
//                )}
//              </div>
//                 )}

//                 <div className="col-lg-4 col-md-4">
//                   <label className="form-label">Network</label>
//                   <Select
//                     className="basic-single"
//                     classNamePrefix="select"
//                     defaultValue={this.state.network[0]}
//                     isSearchable={true}
//                     name="network"
//                     options={this.state.network}
//                     onChange={(selectedOption) => {
//                       this.setState({ selectedNetwork: selectedOption });
//                     }}
//                   />
//                 </div>
//               </div>
              
//               <div className="row">
//                 <div className="col-lg-4 col-md-4">
//                   <label className="form-label">Ratio</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     placeholder="Enter ratio"
//                     value={this.state.ratio}
//                     onChange={(event) => {
//                       this.setState({
//                         ratio: event.target.value
//                       })
//                     }}
//                   />
//                 </div>
                
//                 <div className="col-lg-4 col-md-4 d-flex align-items-end">
//                   <button
//                     className="btn btn-primary w-100"
//                     type="button"
//                     disabled={this.state.isLoading}
//                     onClick={(event) => {
//                       event.preventDefault();
//                       this.onSubmit(event);
//                     }}
//                   >
//                     {this.state.isLoading ? "Processing..." : "Effect Ratio"}
//                   </button>
//                 </div>
//               </div>
//             </form>
//           </div>
//         </div>

//         <div className="card mt-4">
//           <div className="card-header py-3">
//             <h5 className="mb-0">Dealer Ratio History</h5>
//           </div>
//           <div class="card-body">
//             <div class="table-responsive">
//               <table
//                 id="example"
//                 class="table table-striped table-bordered"
//                 style={{ width: "100%" }}
//               >
//                 <thead>
//                   <tr>
//                     <th>ID</th>
//                     <th>Dealer</th>
//                     <th>Network</th>
//                     <th>Merchant ID</th>
//                     <th>Ratio</th>
//                     <th>Transaction Date</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {
//                     this.state.ratios.map((user, index) => {
//                       return (
//                         <tr key={index}>
//                           <td>{index + 1}</td>
//                           <td>{user.dealerId}</td>
//                           <td>{user.telcoName}</td>
//                           <td>{user.merchantId}</td>
//                           <td>{user.ratio || "1"}</td>
//                           <td>{user?.transaction_date}</td>
//                         </tr>
//                       );
//                     }
//                     )
//                   }
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>
//       </main>
//     );
//   }
// }

// export default Switche;


import React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import cookie from "react-cookies";
import Select from "react-select";
import { ENTERPRISE_URL, UNIFIED_BASE_URL } from "../../webbase";

class Switche extends React.Component {
  constructor() {
    super();
    this.state = {
      userEmail: cookie.load("useAdmin"),
      token: cookie.load("tokenAdmin"),
      ratios: [],
      users: [],
      merchants: [],
      selectedDealer: "",
      selectedMerchant: "",
      ratio: "1",
      network: [
        { value: "mtn", label: "MTN" },
        { value: "airtel", label: "Airtel" },
        { value: "glo", label: "Glo" },
        { value: "9mobile", label: "9mobile" },
      ],
      selectedNetwork: { value: "mtn", label: "MTN" },
      isLoading: false,
      dealerSelected: false,
      dealerRatios: [] // <-- for multiple dealer ratios
    };
    this.getRatios = this.getRatios.bind(this);
    this.getDealers = this.getDealers.bind(this);
    this.getMerchants = this.getMerchants.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit = (event) => {
    event.preventDefault();
    this.setState({ isLoading: true });

    const data = {
      merchantId: this.state.selectedMerchant,
      telconame: this.state.selectedNetwork.value,
      dealerRatios: this.state.dealerRatios.length > 0
        ? this.state.dealerRatios
        : [{ dealerId: this.state.selectedDealer, ratio: this.state.ratio }]
    };

    axios
      .post(`${UNIFIED_BASE_URL}/manage/switch-or-ratio-dealer`, data, {
        headers: {
          authorization: this.state.token,
        },
      })
      .then((res) => {
        this.setState({ isLoading: false });
        if (res.data.status === "2000") {
          toast.success(res.data.description);
          this.getRatios();
        } else {
          toast.error(res.data.description);
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false });
        toast.error("An error occurred. Please try again.");
        console.log(err);
      });
  };

  //get all users
  getRatios() {
    axios
      .get(ENTERPRISE_URL + "/manage/get-dealer-router-config", {
        headers: {
          authorization: this.state.token,
        },
      })
      .then((res) => {
        if (res.data.status === "2000") {
          this.setState({
            ratios: res.data.data,
          });
        } else {
          toast.error(res.data.description);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getDealers() {
    this.setState({ isLoading: true });
    axios
      .get(`${UNIFIED_BASE_URL}/manage/get-dealer`, {
        headers: {
          authorization: this.state.token,
        },
      })
      .then((res) => {
        if (res.data.status === "2000") {
          const dealers = res.data.data.map(dealer => ({
            value: dealer.dealerId,
            label: dealer.dealerId
          }));

          this.setState({
            users: dealers,
            isLoading: false
          });
        } else {
          this.setState({ isLoading: false });
          toast.error(res.data.description);
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false });
        toast.error("Failed to fetch dealers");
        console.log(err);
      });
  }

  getMerchants(dealer) {
    this.setState({ isLoading: true, merchants: [] });

    axios
      .get(`${UNIFIED_BASE_URL}/onboarding/get-merchant-by-dealerId?dealerId=${dealer}`, {
        headers: {
          authorization: this.state.token,
        },
      })
      .then((res) => {
        if (res.data.status === "2000") {
          const merchantArray = Array.isArray(res.data.data.merchants)
            ? res.data.data.merchants
            : res.data.data;

          const merchants = (merchantArray || []).map(merchant => ({
            value: merchant.businessEmail,
            label: merchant.businessName ||
              [merchant.firstName, merchant.lastName].filter(Boolean).join(" ") ||
              merchant.businessEmail
          }));

          this.setState({
            merchants,
            isLoading: false
          });

          if (merchants.length > 0) {
            this.setState({ selectedMerchant: merchants[0].value });
          }
        } else {
          this.setState({ isLoading: false });
          toast.error(res.data.description || "Failed to load merchants");
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false });
        toast.error("Failed to fetch merchants");
        console.log(err);
      });
  }

  componentDidMount() {
    this.getRatios();
    this.getDealers();
  }

  render() {
    return (
      <main className="page-content">
        <ToastContainer
          position="top-center"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
          <div className="ps-3">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-0 p-0">
                <li className="breadcrumb-item">
                  <a href="javascript:;">
                    <i className="bx bx-home-alt"></i>
                  </a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  All Dealer Ratios
                </li>
              </ol>
            </nav>
          </div>
          <div className="ms-auto"></div>
        </div>

        <div className="card">
          <div className="card-body">
            <form className="row">
              {/* --- Single Dealer + Merchant Section --- */}
              <div className="row mb-3">
                <div className="col-lg-4 col-md-4">
                  <label className="form-label">Dealer</label>
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    isLoading={this.state.isLoading}
                    isSearchable={true}
                    name="dealer"
                    options={this.state.users}
                    onChange={(selectedOption) => {
                      this.setState({
                        selectedDealer: selectedOption.value,
                        dealerSelected: true,
                        selectedMerchant: "",
                        merchants: []
                      });
                      this.getMerchants(selectedOption.value);
                    }}
                  />
                </div>

                {this.state.dealerSelected && (
                  <div className="col-lg-4 col-md-4">
                    <label className="form-label">Merchant</label>
                    {this.state.isLoading ? (
                      <div className="form-control">Loading merchants...</div>
                    ) : this.state.merchants.length === 0 ? (
                      <div className="text-danger">No merchants found for this dealer</div>
                    ) : (
                      <Select
                        className="basic-single"
                        classNamePrefix="select"
                        isSearchable={true}
                        name="merchant"
                        options={this.state.merchants}
                        onChange={(selectedOption) => {
                          this.setState({ selectedMerchant: selectedOption.value });
                        }}
                      />
                    )}
                  </div>
                )}

                <div className="col-lg-4 col-md-4">
                  <label className="form-label">Network</label>
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    defaultValue={this.state.network[0]}
                    isSearchable={true}
                    name="network"
                    options={this.state.network}
                    onChange={(selectedOption) => {
                      this.setState({ selectedNetwork: selectedOption });
                    }}
                  />
                </div>
              </div>

              <div className="row mb-4">
                {/* <div className="col-lg-4 col-md-4">
                  <label className="form-label">Ratio</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter ratio"
                    value={this.state.ratio}
                    onChange={(event) => {
                      this.setState({
                        ratio: event.target.value
                      });
                    }}
                  />
                </div> */}
              </div>

              {/* --- Multi Dealer Section --- */}
              <div className="row mb-3 mt-4">
                <div className="col-lg-12">
                  <label className="form-label">Select  Dealers</label>
                  <Select
                    isMulti
                    className="basic-multi-select"
                    classNamePrefix="select"
                    isLoading={this.state.isLoading}
                    options={this.state.users}
                    onChange={(selectedOptions) => {
                      const dealerRatios = selectedOptions.map(option => ({
                        dealerId: option.value,
                        ratio: "1"
                      }));
                      this.setState({ dealerRatios });
                    }}
                  />
                </div>
              </div>

              {/* {this.state.dealerRatios && this.state.dealerRatios.length > 0 && (
                <div className="row mt-3">
                  {this.state.dealerRatios.map((dealer, index) => (
                    <div key={index} className="col-lg-4 col-md-6 mb-3">
                      <label className="form-label">{dealer.dealerId} Ratio</label>
                      <input
                        type="number"
                        className="form-control"
                        value={dealer.ratio}
                        onChange={(e) => {
                          const dealerRatios = [...this.state.dealerRatios];
                          dealerRatios[index].ratio = e.target.value;
                          this.setState({ dealerRatios });
                        }}
                      />
                    </div>
                  ))}
                </div>
              )} */}

{this.state.dealerRatios && this.state.dealerRatios.length > 0 && (
  <div className="row mt-3">
    {this.state.dealerRatios.map((dealer, index) => (
      <div key={index} className="col-lg-4 col-md-6 mb-3">
        <label className="form-label">{dealer.dealerId} Ratio</label>
        <input
          type="text"
          className="form-control"
          value={dealer.ratio}
          onChange={(e) => {
            let value = e.target.value;
            // Allow only numbers and at most one decimal point
            value = value.replace(/[^0-9.]/g, "");
            const parts = value.split(".");
            if (parts.length > 2) {
              value = parts[0] + "." + parts[1];
            }

            const dealerRatios = [...this.state.dealerRatios];
            dealerRatios[index].ratio = value;
            this.setState({ dealerRatios });
          }}
        />
      </div>
    ))}
  </div>
)}


              {/* Submit Button */}
              <div className="row">
                <div className="col-lg-4 col-md-4 d-flex align-items-end">
                  <button
                    className="btn btn-primary w-100"
                    type="button"
                    disabled={this.state.isLoading}
                    onClick={(event) => {
                      event.preventDefault();
                      this.onSubmit(event);
                    }}
                  >
                    {this.state.isLoading ? "Processing..." : "Effect Ratio"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div className="card mt-4">
          <div className="card-header py-3">
            <h5 className="mb-0">Dealer Ratio History</h5>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <table
                id="example"
                className="table table-striped table-bordered"
                style={{ width: "100%" }}
              >
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Dealer</th>
                    <th>Network</th>
                    <th>Merchant ID</th>
                    <th>Ratio</th>
                    <th>Transaction Date</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.ratios.map((user, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{user.dealerId}</td>
                      <td>{user.telcoName}</td>
                      <td>{user.merchantId}</td>
                      <td>{user.ratio || "1"}</td>
                      <td>{user?.transaction_date}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </main>
    );
  }
}

export default Switche;
